import { jsx } from 'react/jsx-runtime';
import { ReactComponent as SvgArrowRightMid } from './svg/arrow-right-mid.svg.js';

/**
 * @deprecated - use ArrowRight.
 *
 * @param {boolean} legacyBoundingBox - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {number} size - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {string} title - (optional) will be applied as `aria-label` unless an `aria-label` is explicitly set.
 */
const ArrowRightMid = (props) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { title, size: _size, legacyBoundingBox: _legacyBoundingBox, ...rest } = props;
    return (jsx(SvgArrowRightMid, { viewBox: "-1.33 -1.33 26.66 26.66", "aria-label": title, role: "img", ...rest, width: 24, height: 24, "data-pp-icon": "ArrowRightMid" }));
};

export { ArrowRightMid as default };
//# sourceMappingURL=ArrowRightMid.js.map
